import { gql } from '@apollo/client';

const GET_AFFIRMATIONS = gql`
  query affirmations($where: AffirmationsWhereInput!) {
    affirmations(where: $where) {
      id
      src
      description
      vtt
    }
  }
`;

export default GET_AFFIRMATIONS;
